// ==================== PastAttendance.jsx ====================
import React, { useEffect, useState } from "react";
import { UserCheck } from "lucide-react";
import "../Styling/PastAttendance.css";
import { Base_URL } from "../url";
import { useAuth } from "../Context/AuthContext";
import PastAttendanceModal from "./PastAttendanceModal";

const PastAttendance = () => {
  const [attendanceData, setAttendanceData] = useState([]);
  const [holidays, setHolidays] = useState({}); // ✅ NEW
  const [showModal, setShowModal] = useState(false);

  const { user } = useAuth();
  const userId = user?.userId;
  const orgId = user?.organisationId; // ✅ NEW

  /* ================= Fetch Past 15 Days Attendance ================= */
  useEffect(() => {
    if (!userId) return;

    const fetchPastAttendance = async () => {
      try {
        const apiUrl = `${Base_URL}/Attendance/GetPast15DaysAttendance/${userId}`;
        const response = await fetch(apiUrl);
        const data = await response.json();

        const mappedData = Array.isArray(data)
          ? data.map((item) => ({
              date: item.date,
              status: item.status,
              hours: item.hours,
            }))
          : [];

        setAttendanceData(mappedData);
      } catch (error) {
        console.error("❌ Error fetching past attendance:", error);
      }
    };

    fetchPastAttendance();
  }, [userId]);

  /* ================= Fetch Holidays ================= */
  useEffect(() => {
    if (!orgId) return;

    const fetchHolidays = async () => {
      try {
        const res = await fetch(
          `${Base_URL}/HolidayMasterOrg/GetHolidaysByOrg/${orgId}`
        );
        const data = await res.json();

        const holidayMap = {};
        data
          .filter(
            (h) =>
              h.holidayType === "National" ||
              h.holidayType === "Festival"
          )
          .forEach((h) => {
            holidayMap[new Date(h.holidayDate).toDateString()] =
              h.holidayName;
          });

        setHolidays(holidayMap);
      } catch (error) {
        console.error("❌ Error fetching holidays:", error);
      }
    };

    fetchHolidays();
  }, [orgId]);

  /* ================= CALCULATIONS ================= */
  const isWeekend = (dateStr) => {
    const day = new Date(dateStr).getDay();
    return day === 0 || day === 6;
  };

  const workingDays = attendanceData.filter((day) => {
    const dateKey = new Date(day.date).toDateString();
    return !isWeekend(day.date) && !holidays[dateKey]; // ✅ exclude holidays
  });

  const presentCount = workingDays.filter(
    (day) =>
      day.status?.toLowerCase() === "present" ||
      day.status?.toLowerCase() === "wfh"
  ).length;

  const absentCount = workingDays.length - presentCount;

  return (
    <div className="pastattendance-card compact">
      {/* Header */}
      <div className="pastattendance-header compact">
        <div className="pastattendance-icon small">
          <UserCheck size={16} />
        </div>
        <h4>Past Attendance</h4>

        {/* ONLY this opens modal */}
        <span
          className="header-badge clickable"
          onClick={(e) => {
            e.stopPropagation();
            setShowModal(true);
          }}
        >
          View This Month
        </span>
      </div>

      {/* Attendance Strip */}
      <div className="attendance-strip">
        {attendanceData.map((day, idx) => {
          const dateKey = new Date(day.date).toDateString();
          const holidayName = holidays[dateKey];
          const isHoliday = Boolean(holidayName);

          return (
            <div
              key={idx}
              className={`attendance-pill ${
                isHoliday
                  ? "holiday"
                  : (day.status || "").toLowerCase()
              }`}
              title={
                isHoliday
                  ? `Holiday • ${holidayName}`
                  : `${day.date} • ${day.status} • ${day.hours}`
              }
            >
              <span className="pill-date">
                {new Date(day.date).toLocaleDateString("en-GB", {
                  day: "2-digit",
                  month: "short",
                })}
              </span>

              <span className="pill-hours">
                {isHoliday ? "Holiday" : day.hours}
              </span>
            </div>
          );
        })}
      </div>

      {/* Modal */}
      <PastAttendanceModal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        userId={userId}
      />

      {/* Legend */}
      <div className="attendance-legend">
        <span>
          <i className="dot present"></i> Present: {presentCount}
        </span>
        <span>
          <i className="dot absent"></i> Absent: {absentCount}
        </span>
        <span>
          <i className="dot holiday"></i> Holiday
        </span>
      </div>
    </div>
  );
};

export default PastAttendance;
